import React, { useState, useContext } from 'react';

import { Grid, Paper, Box, Button, Typography} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles';

import useAxios from '../../../hooks/useAxios.js';
import valuationsWebApi from '../../../services/valuationsWebApi.js';
import { LoginContext } from '../../../helpers/Context.js';

const useStyles = makeStyles( (mainTheme) => ({
  buttonStyle:{
    color: "white",
    backgroundColor:mainTheme.palette.primary.main,
    textTransform:"none",
    fontSize:12,
    margin: "10px",
    //marginTop: "15px",
    "&:hover": {
      color:mainTheme.palette.secondary.main,
      backgroundColor:mainTheme.palette.primary.main,
    },
  },
  }))

export default function ShowLatestValuations (){
  const classes = useStyles();
  const { userData } = useContext(LoginContext);
  const { userId } = userData;
  const [ savedValuationsList, setSavedValuationsList ] = useState([])
  const { axiosFetch: getAllValuations, isLoading: isLoadingAllValuations, error: isErrorAllValuations } = useAxios();

  const getAllValuationsSuccessCb=(apiData)=>{ 
    const dataFromApi = apiData.map(item => ({
      ...item,
      updatedAt: new Date(item.updatedAt)
    }));
    const sortedArrayDescending = dataFromApi.sort((a, b) => b.updatedAt - a.updatedAt);
    setSavedValuationsList(sortedArrayDescending)
  }

  const getAllValuationsErrorCb=(apiData)=>{
    // alert("Error fetching valuations")
  }

  const getSavedValuations=()=>{
    getAllValuations({ axiosInstance: valuationsWebApi, method: 'GET', url: '/valuations', requestConfig: { headers: {'Authorization': userId,},}},getAllValuationsSuccessCb, getAllValuationsErrorCb);
  }

  return ( 
    <>
    { userId==="martincsl@hotmail.com" ? 
      <>
      <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" >
    
          <Grid item xs={12} md={6} >
            <Paper className={classes.paper} elevation={12}>
              <Button 
                variant = "contained" 
                disableRipple
                onClick = {getSavedValuations} 
                className = {classes.buttonStyle}
                >Get Latest valuations
              </Button>
            </Paper>
            <Box style={{height:"10px", backgroundColor:"green"}}/>
          </Grid>
          { savedValuationsList.length > 0 ? 
            
            <Paper elevation={12}>
              <Typography>{`Total de valuations: ${savedValuationsList.length}`}</Typography>
                <>
                  { savedValuationsList.map ((currValuation)=>(<>
                    <Typography>{`ValuationId${currValuation.valuationId} from ${currValuation.userId} of ticker ${currValuation.companyId} updated at ${currValuation.updatedAt}}`}</Typography>
                    </>
                  ))}
                </>
            </Paper>
          : null}
      </Grid>
    </>
    : 
    null }
  </>
  )
}